var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"text"},[_vm._t("default"),_c('button',{ref:"appealDescMoreButton",class:[{ [_vm.collapseClass]: _vm.shown, [_vm.unCollapseClass]: !_vm.shown }],attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.appealDescMore.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.openButtonName)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }